import { render, staticRenderFns } from "./MakeMoldList.vue?vue&type=template&id=fcd2d32c"
import script from "./MakeMoldList.vue?vue&type=script&lang=js"
export * from "./MakeMoldList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports